import BaseObject from '../../../base/base_object';
import ServiceFactory from '../../service_factory';

export default class JackpotFeedsReader extends BaseObject {
    static CLASS = 'JackpotFeedsReader';
    private _serviceFactory: ServiceFactory;
    private _getJackpotsUrl: string;
    private _getGameJackpotUrl: string;

    init(params) {
        super.init(params);
        if(!params.serviceFactory) {
            this.throwArgumentExpected('13', 'init', 'serviceFactory');
        }

        if(!params.getJackpotsUrl) {
            this.throwArgumentExpected('17', 'init', 'getJackpotsUrl');
        }

        if(!params.getGameJackpotUrl) {
            this.throwArgumentExpected('21', 'init', 'getGameJackpotUrl');
        }

        this._serviceFactory = params.serviceFactory;
        this._getJackpotsUrl = params.getJackpotsUrl;
        this._getGameJackpotUrl = params.getGameJackpotUrl;
    }

    readAll() {
        if(!this._serviceFactory.currencyService().getCurrency()) {
            const message = `Not call to jackpot readAll due to
                 Currency is: ${this._serviceFactory.currencyService().getCurrency()}.`;
            this.logger.error(message);
            return Promise.reject(message);
        }
        return this._serviceFactory.integrationService().getAllGameTypes()
            .then(gameTypes => {
                return this._serviceFactory.http2Service().post(this._getJackpotsUrl, {
                    brandId: this._serviceFactory.skinService().getBrandID(),
                    currency: this._serviceFactory.currencyService().getCurrency(),
                    gamesList: JSON.stringify(gameTypes)
                });
            });
    }

    readGameJackpot(gameType) {
        if(!this._serviceFactory.currencyService().getCurrency()) {
            const message = `Not call to jackpot readGameJackpot due to
                 Currency is: ${this._serviceFactory.currencyService().getCurrency()}.`;
            this.logger.error(message);
            return Promise.reject(message);
        }
        return this._serviceFactory.http2Service().post(this._getGameJackpotUrl, {
            brandId: this._serviceFactory.skinService().getBrandID(),
            currency: this._serviceFactory.currencyService().getCurrency(),
            gameType: gameType
        });
    }
}